<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { LocationStore, LocationsStore } from '../stores'

    import LocationsService from '../$services/locations.service'
    import DateMethods from '../$methods/date.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

    const dispatch = createEventDispatcher()

    let loading = false

    async function deleteLocation() {
    
        loading = true
        const resp = await LocationsService.deleteLocation($LocationStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        LocationsStore.remove($LocationStore._id)
        LocationStore.set(null)

        toast({message: 'Dirección borrada', type: 'is-success'})
        dispatch('deleted')
    }

</script>

{#if $LocationStore}
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <Button on:click={() => LocationStore.modalUpdate($LocationStore)} icon="edit" text="Actualizar" color="primary" size="small" />
                <ButtonDelete on:confirm={ deleteLocation } {loading} />
            </div>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Alias" value={ $LocationStore.alias } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Contacto" value={ $LocationStore.contact } />
        </div>
        <div class="column">
            <Value label="Empresa" value={ $LocationStore.company || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $LocationStore.rfc } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Teléfono" value={ $LocationStore.phone } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Correo" value={ $LocationStore.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Código postal" value={ $LocationStore.zipcode } />
        </div>
        <div class="column">
            <Value label="Estado" value={ $LocationStore.state } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Ciudad" value={ $LocationStore.city } />
        </div>
        <div class="column">
            <Value label="Municipio" value={ $LocationStore.municipality || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Colonia" value={ $LocationStore.colony } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Calle" value={ $LocationStore.street } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Número exterior" value={ $LocationStore.number } />
        </div>
        <div class="column">
            <Value label="Número interior" value={ $LocationStore.apartment || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Referencias" value={ $LocationStore.references || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Entre calles" value={ $LocationStore.betweenStreets } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Google Maps" value="Ver mapa" link={ `https://www.google.com/maps/search/?api=1&query=${$LocationStore.coordinates.lat},${$LocationStore.coordinates.lng}` } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateTimeLarge($LocationStore.created) } />
        </div>
    </div>
{/if}